import React from "react";

import { Grid as MuiGrid, GridProps as MuiGridProps } from "@mui/material";

export interface IGrid extends MuiGridProps {
  children: React.ReactNode;
}

export const Grid: React.FC<IGrid> = ({ children, ...props }) => {
  return <MuiGrid {...props}>{children}</MuiGrid>;
};

export default Grid;
